"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuth } from "@/contexts/auth-context";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, user, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (loading) return;
    if (!isAuthenticated) {
      router.replace("/login");
      return;
    }
    if (user && !user.enabled) {
      // User is authenticated but disabled - redirect to waitlist
      router.replace("/sign-up/portal");
    }
  }, [isAuthenticated, user, loading, router]);

  if (loading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <div className="text-center">
          <h2 className="text-lg font-semibold">Loading...</h2>
          <p className="text-sm text-muted-foreground">Please wait while we verify your authentication</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || (user && !user.enabled)) return null;

  return <>{children}</>;
} 